export default __webpack_public_path__ + "static/media/squat-rack.694b709d.jpg";